"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagediyDeleteApi = pagediyDeleteApi;
exports.pagediyGetSetHome = pagediyGetSetHome;
exports.pagediyInfoApi = pagediyInfoApi;
exports.pagediyListApi = pagediyListApi;
exports.pagediySaveApi = pagediySaveApi;
exports.pagediySetdefaultApi = pagediySetdefaultApi;
exports.pagediyUpdateApi = pagediyUpdateApi;
exports.pagediyUpdatenameApi = pagediyUpdatenameApi;
exports.wechatQrcodeApi = wechatQrcodeApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * @description 新增商户装修模板
 */
function pagediySaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/page/diy/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户装修模板分页列表
 */
function pagediyListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/page/diy/page',
    method: 'get',
    params: params
  });
}

/**
 * @description diy 详情
 */
function pagediyInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 编辑商户装修模板
 */
function pagediyUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/update",
    method: 'post',
    data: data
  });
}

/**
 * @description 设置商户装修默认首页
 */
function pagediySetdefaultApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/set/default/".concat(id),
    method: 'post'
  });
}

/**
 * @description 删除商户装修模板
 */
function pagediyDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 获取商户装修默认首页ID
 * @returns {*}
 */
function pagediyGetSetHome() {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/get/default/id",
    method: 'get'
  });
}

/**
 * 获取小程序二维码
 * @returns {*}
 */
function wechatQrcodeApi(data) {
  return (0, _request.default)({
    url: "/publicly/wechat/mini/get/qrcode",
    method: 'post',
    data: data
  });
}

/**
 * 编辑商户装修模板名称
 * @returns {*}
 */
function pagediyUpdatenameApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/page/diy/update/name",
    method: 'post',
    data: data
  });
}